export const generalConstants = [
  { value: 1, label: 'Included' },
  { value: 2, label: 'Not Included' },
]

export const yesNoOptions = [
  { value: 1, label: 'Yes' },
  { value: 2, label: 'No' },
]

export const dayInWeekOptions = [
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
  { value: 7, label: 'Sunday' },
]

export const defaultDateRange = [
  { value: 1, label: 'This Week' },
  { value: 2, label: 'Last Week' },
  { value: 3, label: 'This Month' },
  { value: 4, label: 'Last Month' },
  { value: 5, label: 'This Quarter' },
  { value: 6, label: 'Last Quarter' },
  { value: 7, label: 'This Year' },
  { value: 8, label: 'Last Year' },
]
export const dateRangeAccountInfo = [
  { value: 1, label: 'This Week' },
  { value: 2, label: 'Last Week' },
  { value: 3, label: 'This Month' },
  { value: 4, label: 'Last Month' },
  { value: 5, label: 'This Quarter' },
  { value: 6, label: 'Last Quarter' },
  { value: 7, label: 'This Year' },
  { value: 8, label: 'Last Year' },
]

export const dealStatus = [
  { value: 1, label: 'New' },
  { value: 2, label: 'In review' },
  { value: 3, label: 'Accepted' },
  { value: 4, label: 'Denied' },
  { value: 5, label: 'Approved not funded' },
  { value: 6, label: 'Closed' },
  { value: 7, label: 'Funded' },
]
